module.exports = "/_next/static/images/da9e3628f4f9f6195c897685f99a9c45-cuenta-card-lg.png";